module.exports = __webpack_public_path__ + "img/PD1505006921550266368.cbdf2d02.png";